/** localStorage for previous-product question (/switch). */
export const SWITCH_STORAGE_KEY = 'ploomsurvey:switch';

export type SwitchAnswer = 'cigarette' | 'vape' | 'other_htp' | 'na_first';

export type SwitchAnswers = {
  previousProduct: SwitchAnswer;
};

export function readSwitchAnswers(): SwitchAnswers | null {
  try {
    const raw = localStorage.getItem(SWITCH_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const r = (o as { previousProduct?: unknown }).previousProduct;
    if (r === 'cigarette' || r === 'vape' || r === 'other_htp' || r === 'na_first') {
      return { previousProduct: r };
    }
    return null;
  } catch {
    return null;
  }
}

export function writeSwitchAnswers(data: SwitchAnswers): void {
  try {
    localStorage.setItem(SWITCH_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearSwitchAnswers(): void {
  try {
    localStorage.removeItem(SWITCH_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isSwitchComplete(): boolean {
  return readSwitchAnswers() != null;
}
